import router from '@/router';

const normalize = (str: string) => str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
export const searchMatcher = (x: string, filter: string) => normalize(x).indexOf(normalize(filter)) > -1;


export function navigateToSearch(filter: string) {
    router.push({
        name: 'home',
        query: { q:  filter},
    });
}